import { HelpCenterDataProvider } from '..';

const fallback = () => {
  console.error('Incorrect HelpCenter data provider.');
  return Promise.reject();
};

const dp: HelpCenterDataProvider = {
  getSoftwareInfo: fallback,
};

export const getHelpCenterDataProvider = (): HelpCenterDataProvider => {
  // ensure to return same instance as this function could be called in
  // hooks frequently.
  return dp;
};
